import { message } from 'antd';

const Message = ({ type = 'success', content }) => message[type](content);
export default Message;
